import type { RouteRecordRaw } from 'vue-router';

import { LAYOUT_DEFAULT } from '~~/router/router.entity';

const processingRoute: RouteRecordRaw = {
  path: '/profile',
  name: '/profile-root',
  component: LAYOUT_DEFAULT,
  meta: {
    localIcon: 'users-black',
    i18nKey: 'routes.profile',
    title: 'profile',
    hideInMenu: true,
  },
  children: [
    {
      path: '',
      name: '/profile',
      component: () => import('~~/pages/profile.vue'),
      meta: {
        localIcon: 'users-black',
        i18nKey: 'routes.profile',
        title: 'profile',
        hideInMenu: true,
      },
    },
  ],
};

export default processingRoute;
